import Icon from '../Icon';

const TooltipClose = (props) => {
  const { color, ...rest } = props;
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        d="M8.70639 8.00002L13.0197 3.68669C13.108 3.5919 13.1561 3.46654 13.1538 3.337C13.1516 3.20747 13.0991 3.08388 13.0075 2.99227C12.9159 2.90066 12.7923 2.84819 12.6627 2.8459C12.5332 2.84362 12.4078 2.8917 12.3131 2.98002L7.99972 7.29335L3.68639 2.98002C3.59161 2.8917 3.46624 2.84362 3.33671 2.8459C3.20717 2.84819 3.08358 2.90066 2.99197 2.99227C2.90037 3.08388 2.84789 3.20747 2.84561 3.337C2.84332 3.46654 2.8914 3.5919 2.97972 3.68669L7.29306 8.00002L2.97972 12.3134C2.88609 12.4071 2.8335 12.5342 2.8335 12.6667C2.8335 12.7992 2.88609 12.9263 2.97972 13.02C3.07347 13.1137 3.20056 13.1662 3.33306 13.1662C3.46556 13.1662 3.59264 13.1137 3.68639 13.02L7.99972 8.70669L12.3131 13.02C12.4068 13.1137 12.5339 13.1662 12.6664 13.1662C12.7989 13.1662 12.926 13.1137 13.0197 13.02C13.1134 12.9263 13.1659 12.7992 13.1659 12.6667C13.1659 12.5342 13.1134 12.4071 13.0197 12.3134L8.70639 8.00002Z"
        stroke={color}
      />
    </Icon>
  );
};

export default TooltipClose;
